export default {
  data() {
    return {
      // eslint-disable-next-line
      searchUserStatus: [
        "Active",
        "Disabled"
      ],
      // eslint-disable-next-line
      searchUserLicence: [
        "Free",
        "Unlimited"
      ]
    };
  }
};
